import { TableFilterConfig, FilterFieldConfig } from 'hooks';

/**
 * Filter fields for Approvals table
 * Each field corresponds to a filterable column in the table
 */
export const APPROVALS_FILTER_FIELDS: FilterFieldConfig[] = [
    { id: 'action', type: 'text', label: 'Action' },
    { id: 'user', type: 'text', label: 'Name' },
    { id: 'userSign', type: 'text', label: 'Signature' },
    { id: 'createDate', type: 'text', label: 'Time Stamp' },
    { id: 'siteName', type: 'text', label: 'Site Name' },
    { id: 'monthYear', type: 'text', label: 'Month/Year' },
];

/**
 * Type definition for Approvals filters
 */
export interface ApprovalsFilters {
    action: string | null;
    user: string | null;
    userSign: string | null;
    createDate: string | null;
    siteName: string | null;
    monthYear: string | null;
}

/**
 * Filter configuration for Approvals page
 * Uses localStorage for persistence
 */
export const filterConfig: TableFilterConfig<ApprovalsFilters> = {
    localStorageKey: 'approvals-page-filters',
    fields: APPROVALS_FILTER_FIELDS,
    filterMode: 'column',
};

